import type { InjectionKey } from 'vue';
import type PSPDFKit from 'pspdfkit';
import type { Instance, Point } from 'pspdfkit';
import type { Point2D } from '@/types/objects';

export interface Marking {
    question_id: number;
    page: number;
    height: number;
    width: number;
    ystart: number;
    xstart: number;
    page_height: number;
    page_width: number;
}

export type InitialMarking = Omit<Marking, 'question_id'>;

// PSPDFKit does not provide its types well.
// In order to still have a good type coverage, we pick the ones we actually use/need.
// Feel free to specify more types if needed.
export const providePSPDFKit: InjectionKey<{
    load: typeof PSPDFKit.load;
    unload: typeof PSPDFKit.unload;
    Geometry: typeof PSPDFKit.Geometry;
    Immutable: typeof PSPDFKit.Immutable;
    ViewState: typeof PSPDFKit.ViewState;
    CustomOverlayItem: typeof PSPDFKit.CustomOverlayItem;
}> = Symbol('providePSPDFKit');

export const providePdfViewerKey: InjectionKey<Instance | null> = Symbol('pdf-viewer');
export const provideTransformScreenToPageSpaceKey: InjectionKey<(point: Point2D, pageIndex: number) => Point> =
    Symbol('pdf-viewer-offset-func');
